/**
 * Interface for correlation context information
 */
export interface CorrelationContext {
  correlationId: string;
  sessionId: string;
  timestamp: string;
  actionName?: string;
  actionData?: any;
}

/**
 * Interface for user action tracking
 */
export interface UserAction {
  actionName: string;
  correlationId: string;
  timestamp: string;
  component?: string;
  data?: any;
}

/**
 * Interface for HTTP request correlation
 */
export interface HttpCorrelation {
  correlationId: string;
  method: string;
  url: string;
  timestamp: string;
  duration?: number;
  status?: number;
  error?: any;
}

/**
 * Enum for common user actions
 */
export enum UserActionType {
  LOGIN = 'login',
  LOGOUT = 'logout',
  REGISTER = 'register',
  NAVIGATION = 'navigation',
  FORM_SUBMIT = 'form_submit',
  BUTTON_CLICK = 'button_click',
  DATA_LOAD = 'data_load',
  SEARCH = 'search',
  FILTER = 'filter',
  SORT = 'sort',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  VIEW = 'view'
}

/**
 * Interface for correlation configuration
 */
export interface CorrelationConfig {
  enableConsoleLogging: boolean;
  enableSessionStorage: boolean;
  enableAnalytics: boolean;
  logLevel: 'debug' | 'info' | 'warn' | 'error';
}